<template>
  <div v-if="validation.$error" class="invalid-feedback">
    <div v-if="validation.required === false">
      <slot name="required" v-bind="{ value }">
        {{ `${value} is required.` | capitalize }}
      </slot>
    </div>
    <div v-else-if="validation.maxLength === false">
      <slot name="maxLength" v-bind="{ value }">
        {{ `${value} must have maximum ${validation.$params.maxLength.max} characters.` | capitalize }}
      </slot>
    </div>
    <div v-else>
      <slot name="invalid">{{ `${value} is invalid` }}</slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FormFeedback',

    props: {
      validation: Object,
      field: String,
    },

    computed: {
      value() {
        return this.field || 'value';
      },
    },
  };
</script>

<style scoped></style>
